import React from 'react';
import Dropdown from './Dropdown.js';

import './filters.css';
function Filters({handleChange, filters}) {
    const availables = ['None', 'Alpha', 'Beta', 'Gamma', 'Theta', 'Delta', 'Alpha/Delta', 'Theta/Beta'];

    function handleSelectChange(filter, value) {
        handleChange({...filters, [filter]:value});
    }

    return(
        <div className='div_filters'>
            {Object.keys(filters).map( (filter) => <Dropdown key={filter} name={filter} availables={availables} handleChange={handleSelectChange} />)}
        </div>
    )
}

export default Filters;